// @flow

import { handlePaginatedMapRequest } from '../phasedActionHelpers';

import type { LoadConductorsAction } from '../../actions/conductor';

export type State = {
  +[key: string]: {|
    +loading: boolean,
    +loaded: boolean,
    +loadedCursors: { [key: string]: boolean },
    +entities: Array<number>,
    +meta: {
      +count: number,
      +cursor: { +next: ?string, +prev: ?string },
    },
  |},
};

const initialState = {};

export default function conductors(state: State = initialState, action: LoadConductorsAction) {
  if (action.type === 'FETCH_CONDUCTORS' && action.cacheId) {
    return handlePaginatedMapRequest(state, action, action.cacheId);
  }

  return state;
}
